import * as React from 'react';

interface Props {
  activityData: {
    data?: [Record<string, string>]
  };
}

function KeyActivityTable (props: Props) {

  const { activityData } = props;

  if (undefined !== activityData.data && activityData.data.length) {
    const keyArr = Object.keys(activityData.data[0]);

    return keyArr.sort().map((item, key) => {
      return (
        <div
          key={key}
          className='d-flex border-row'>
          <div className='key-action-title bold'>
            {item[0].toUpperCase() + item.slice(1).split('_').join(' ')}
          </div>
          <div className='key-action-text'>{activityData.data[0][item]}</div>
        </div>
      );
    });
  } else {
    return null;
  }

}

// @ts-ignore
export default React.memo(KeyActivityTable);
